import {Selector} from '@ngxs/store';
import {CommandStatus} from '../../models/command-response';
import {PanelOutputGroup} from '../../models/panel-output-group';
import {PanelOutput} from '../../models/panel-output.interface';


import {groupByGroup} from '../../utils/group-outputs';

import {PanelOutputsStateModel} from './panel-outputs.model';

import {PanelOutputsState} from './panel-outputs.state';

export class PanelOutputsStateSelectors {
  @Selector([PanelOutputsState])
  static userPanelOutputs(state: PanelOutputsStateModel): PanelOutput[] {
    return state.userPanelOutputs.filter(output => output.name.includes(state.searchTerm));
  }

  @Selector([PanelOutputsState])
  static userPanelOutputGroups(state: PanelOutputsStateModel): PanelOutputGroup[] {
    return groupByGroup(state.userPanelOutputs.filter(output => output.name.includes(state.searchTerm)));
  }

  @Selector([PanelOutputsState])
  static selectedOutput(state: PanelOutputsStateModel): PanelOutput {
    return state.selectedPanelOutput;
  }

  @Selector([PanelOutputsState])
  static selectedGroup(state: PanelOutputsStateModel): PanelOutputGroup {
    return state.selectedPanelOutputGroup;
  }

  @Selector([PanelOutputsStateModel])
  static selectedGroupOutputs(state: PanelOutputsStateModel): PanelOutput[] {
    return state.selectedPanelOutputGroup.outputs;
  }

  @Selector([PanelOutputsState])
  static commandStatus(state: PanelOutputsStateModel): CommandStatus {
    return state.commandStatus;
  }

}
